import { Component, Event, Method, Prop, State, Watch, h } from '@stencil/core';
import { StreetTypes } from '../address.model';
import { generateRandomNumber } from '../../../../global/utils/utils';
import leftArrow from '../../../../assets/agl_left_arrow.svg';
import { postCodeRegEx } from './manual-address-entry.validation';
//do in and out
export class ManualAddressEntryComponent {
  constructor() {
    /**
     * The manual address ID
     */
    this.manualAddressId = generateRandomNumber();
    /**
     *Heading for the modal
     */
    this.heading = '';
    /**
     * includePobox will give option to choose postal/pobox, which indicates a mailing address entry.
     */
    this.includePobox = false;
    /**
     * Default form value as object
     */
    this.defaultAddressDetail = {};
    this.addressDetailState = this.modifyAddressDetails(this.defaultAddressDetail, true);
    this.addressTypeState = 'postal';
    this.invalidFields = [];
    this.isFormInvalid = false;
    this.firstInvalidInputId = '';
    this.streetNumber = this.manualAddressId + 'streetNumber';
    this.streetName = this.manualAddressId + 'streetName';
    this.streetType = this.manualAddressId + 'streetType';
    this.suburb = this.manualAddressId + 'suburb';
    this.state = this.manualAddressId + 'state';
    this.postcode = this.manualAddressId + 'postcode';
    this.poBoxNumber = this.manualAddressId + 'poBoxNumber';
    this.poBoxType = this.manualAddressId + 'poBoxType';
    this.requiredFields = [this.streetNumber, this.streetName, this.streetType, this.suburb, this.state, this.postcode];
  }
  modifyAddressDetails(addressDetails, addUniqueId) {
    //adds or subtracts the unique id for import/export
    const defaultAddressDetailArray = Object.keys(addressDetails);
    const defaultAddressDetail = {};
    defaultAddressDetailArray.map((item) => {
      if (addUniqueId) {
        defaultAddressDetail[this.manualAddressId + item] = addressDetails[item];
      }
      else {
        defaultAddressDetail[item.replace(this.manualAddressId, '')] = addressDetails[item];
      }
    });
    return defaultAddressDetail;
  }
  handleFieldBlur(fieldName, value) {
    this.setValue(fieldName, value);
    this.validateField(fieldName, value);
    this.validateFormWhenCompleted(fieldName);
  }
  setValue(fieldName, value) {
    const newValueObject = Object.assign({}, this.addressDetailState);
    newValueObject[`${fieldName}`] = value;
    this.addressDetailState = newValueObject;
  }
  contains(fieldName, name) {
    return fieldName.indexOf(name) > -1;
  }
  validateField(fieldName, value) {
    const regex = {
      alphaNum: /^[0-9a-zA-Z][0-9a-zA-Z\s]*$/,
      streetName: /^[a-zA-Z][a-zA-Z \-']*$/,
      alpha: /^[a-zA-Z][a-zA-Z ]*$/
    };
    switch (true) {
      case this.contains(fieldName, 'streetName'):
      case this.contains(fieldName, 'streetType'):
      case this.contains(fieldName, 'suburb'):
        this.validateFieldWithRegex(fieldName, value, regex.alpha);
        break;
      case this.contains(fieldName, 'streetNumber'):
        this.validateFieldWithRegex(fieldName, value);
        break;
      case this.contains(fieldName, 'poBoxNumber'):
        this.validateFieldWithRegex(fieldName, value);
        break;
      case this.contains(fieldName, 'poBoxType'):
        this.validateFieldWithRegex(fieldName, value);
        break;
      case this.contains(fieldName, 'state'):
        this.validateStateField(value, postCodeRegEx);
        break;
      case this.contains(fieldName, 'postcode'):
        this.validatePostcodeField(value, postCodeRegEx);
        break;
      default:
        this.validateFieldWithRegex(fieldName, value);
        break;
    }
  }
  validateFieldWithRegex(fieldName, value, regexRule) {
    if (regexRule) {
      if (value && regexRule.test(value)) {
        this.setFieldValid(fieldName);
      }
      else {
        this.setFieldInvalid(fieldName);
      }
    }
    else {
      if (value && value.trim()) {
        this.setFieldValid(fieldName);
      }
      else {
        this.setFieldInvalid(fieldName);
      }
    }
  }
  validateStateField(value, postcodeRegex) {
    //if postcode is valid by default validation
    if (this.addressDetailState[this.postcode] && postcodeRegex.default.test(this.addressDetailState[this.postcode])) {
      //use state value to get regex to validate postcode
      if (value && postcodeRegex[`${value.toLowerCase()}`].test(this.addressDetailState[this.postcode])) {
        this.setFieldValid(this.state);
        this.setFieldValid(this.postcode);
      }
      else if (!value) {
        this.setFieldInvalid(this.state);
      }
      else {
        this.postcodeDropdown.validationText = 'State and postcode do not match';
        this.stateDropdown.validationText = 'State and postcode do not match';
        this.setFieldInvalid(this.state);
        this.setFieldInvalid(this.postcode);
      }
    }
    else {
      //postcode has no value or postcode is invalid, use default validation for state
      this.validateFieldWithRegex(this.state, value);
    }
  }
  validatePostcodeField(value, postcodeRegex) {
    //if state is valid by default validation
    if (this.addressDetailState[this.state]) {
      //when postcode value passed in, validate with state based regex
      if (value && postcodeRegex[`${this.addressDetailState[this.state].toLowerCase()}`].test(value)) {
        this.setFieldValid(this.state);
        this.setFieldValid(this.postcode);
      }
      else if (!value) {
        this.setFieldInvalid(this.postcode);
      }
      else {
        this.postcodeDropdown.validationText = 'State and postcode do not match';
        this.stateDropdown.validationText = 'State and postcode do not match';
        this.setFieldInvalid(this.state);
        this.setFieldInvalid(this.postcode);
      }
    }
    else {
      //state has no value or state is invalid, use default validation for postcode
      this.validateFieldWithRegex(this.postcode, value, postcodeRegex.default);
    }
  }
  isFieldValid(fieldName) {
    return this.invalidFields.join().indexOf(fieldName) <= -1;
  }
  setFieldValid(fieldName) {
    if (this.isFieldValid(fieldName)) {
      return;
    }
    this.invalidFields = this.invalidFields.filter((item) => item !== fieldName);
  }
  setFieldInvalid(fieldName) {
    if (!this.isFieldValid(fieldName)) {
      return;
    }
    this.invalidFields = [...this.invalidFields, fieldName];
  }
  validateFormWhenCompleted(fieldName) {
    if (!this.isFormInvalid) {
      return;
    }
    if (!this.isFieldValid(fieldName)) {
      return;
    }
    let isCompleted = true;
    this.requiredFields.forEach((fieldname) => {
      if (!this.addressDetailState[fieldname]) {
        isCompleted = false;
      }
    });
    if (isCompleted && this.validateForm()) {
      this.isFormInvalid = false;
    }
  }
  validateForm() {
    let isValid = true;
    this.requiredFields.forEach((fieldName) => {
      const tmpFieldName = fieldName;
      this.validateField(tmpFieldName, this.addressDetailState[fieldName]);
      if (!this.isFieldValid(tmpFieldName)) {
        isValid = false;
      }
    });
    return isValid;
  }
  updateRequiredFields() {
    if (this.addressTypeState === 'postal') {
      this.requiredFields = [this.streetNumber, this.streetName, this.streetType, this.suburb, this.state, this.postcode];
    }
    else {
      this.requiredFields = [this.poBoxType, this.poBoxNumber, this.suburb, this.state, this.postcode];
    }
  }
  clearValueOnUnrequiredFields() {
    let unrequiredFields;
    this.addressTypeState === 'postal'
      ? (unrequiredFields = [this.poBoxType, this.poBoxNumber])
      : (unrequiredFields = [this.streetNumber, this.streetName, this.streetType]);
    unrequiredFields.forEach((fieldName) => {
      const newAddressModel = Object.assign({}, this.addressDetailState);
      newAddressModel[`${fieldName}`] = null;
      this.addressDetailState = newAddressModel;
    });
  }
  resetFormState() {
    this.addressDetailState = {};
    this.invalidFields = [];
    this.isFormInvalid = false;
    this.addressTypeState = this.includePobox ? 'poBox' : 'postal';
    this.firstInvalidInputId = '';
  }
  updateWhenAddressTypeChange() {
    this.updateRequiredFields();
    //reset invalid fields
    this.invalidFields = [];
  }
  updateRequiredfieldsWhenPoBoxTypeChange(oldValue, newValue) {
    if (oldValue && newValue && oldValue['poBoxType'] !== newValue['poBoxType']) {
      this.updateRequiredFields();
    }
  }
  updateFirstInvalidInputId() {
    let hasFirstInvalidFieldFound = false;
    let firstInvalidField;
    this.requiredFields.forEach((requiredField) => {
      if (hasFirstInvalidFieldFound)
        return;
      if (!this.isFieldValid(requiredField)) {
        firstInvalidField = requiredField;
        hasFirstInvalidFieldFound = true;
      }
    });
    if (firstInvalidField === this.state || firstInvalidField === this.poBoxType) {
      this.firstInvalidInputId = `${firstInvalidField}_dropdown__button`;
    }
    else {
      this.firstInvalidInputId = `${firstInvalidField}_textBox`;
    }
  }
  /**
   * Public method to open the modal
   * @param {HTMLElement} el, the element need to be focused after modal close
   * @deprecated This will not be supported when the parameter is removed from the modal
   */
  async openModal(el) {
    this.modalContainer.openModal(el);
    if (this.includePobox) {
      this.addressType.selectedValue = 'poBox';
    }
  }
  /**
   * Public method to set the modal trigger element
   * @param {Function} getTriggerButton, The anonymous function that returns the element that needs to be focused after modal close
   */
  async setTriggerButton(getTriggerButton) {
    this.modalContainer.setTriggerButton(getTriggerButton);
  }
  componentWillLoad() {
    this.addressTypeState = this.includePobox ? 'poBox' : 'postal';
  }
  render() {
    return (h("agl-ds-modal", { appearance: "centerscreen", animationType: "popup", disableScroll: true, ref: (el) => (this.modalContainer = el), onModalClosed: (event) => {
        this.resetFormState();
        this.addressCloseAction.emit(event === null || event === void 0 ? void 0 : event.detail);
      } },
      h("div", { slot: "header" },
        h("agl-ds-h2", { bottomMargin: "none", styledAs: "title3" }, this.heading)),
      h("div", { slot: "content" },
        this.includePobox && [
          h("agl-ds-radio-button-group", { ref: (el) => (this.addressType = el), groupName: "addressType", onChange: (e) => {
              this.addressTypeState = e.target.value;
              this.isFormInvalid = false;
            }, selectedValue: 'poBox' },
            h("agl-ds-radio-button-set", null,
              h("agl-ds-radio-button", { groupName: "addressType", value: "postal" }, "Postal address"),
              h("agl-ds-radio-button", { groupName: "addressType", value: "poBox" }, "PO BOX address"))),
          h("agl-ds-spacer", { orientation: "vertical", size: "space04" })
        ],
        this.isFormInvalid && (h("agl-ds-error-summary", { ref: (el) => (this.errorNotification = el), id: "errorNotification", invalidFieldCount: this.invalidFields.length, firstInvalidInputId: this.firstInvalidInputId })),
        this.addressTypeState === 'postal' && (h("div", null,
          h("div", { class: "row" },
            h("div", { class: "col-sm-12 col-md-6" },
              h("agl-ds-textbox", { label: 'Unit number', hintText: "If applicable", maxLength: 100, value: this.addressDetailState.unitNumber, onTextboxBlur: (e) => {
                  this.setValue('unitNumber', e.detail.target.value);
                } })),
            h("div", { class: "col-sm-12 col-md-6" },
              h("agl-ds-textbox", { id: this.streetNumber, textBoxId: this.streetNumber + `_textBox`, label: "Street number", maxLength: 100, validationText: "Street number required", onTextboxBlur: (e) => {
                  this.handleFieldBlur(this.streetNumber, e.detail.target.value);
                }, hasError: !this.isFieldValid(this.streetNumber), value: this.addressDetailState[this.streetNumber] }))),
          h("agl-ds-textbox", { id: this.streetName, label: "Street name", textBoxId: this.streetName + '_textBox', maxLength: 100, inputType: "text", validationText: "Street name required", onTextboxBlur: (e) => {
              this.handleFieldBlur(this.streetName, e.detail.target.value);
            }, hasError: !this.isFieldValid(this.streetName), value: this.addressDetailState[this.streetName] }),
          h("agl-ds-autocomplete", { autoCompleteId: this.streetType, label: "Street type", options: StreetTypes.map((type) => {
              return { value: type, text: type };
            }), onAutocompleteOptionSelected: (e) => {
              e.stopPropagation();
              this.handleFieldBlur(this.streetType, e.detail.value);
            }, value: this.addressDetailState[this.streetType], hasError: !this.isFieldValid(this.streetType), validationText: "Street type required (e.g. Road Avenue Blvd)", hintText: "e.g. Road Avenue Blvd" }))),
        this.addressTypeState === 'poBox' && (h("div", { class: "row" },
          h("div", { class: "col-sm-12 col-md-6" },
            h("agl-ds-dropdownbox", { id: this.poBoxType, selectId: this.poBoxType + '_dropdown', label: "PO Box Type", validationText: "PO Box type required", hintText: "Select from list", value: this.addressDetailState[this.poBoxType], onOptionSelected: (e) => {
                this.handleFieldBlur(this.poBoxType, e.detail.value);
              }, onDropdownClosed: (e) => {
                this.handleFieldBlur(this.poBoxType, e.detail);
              }, hasError: !this.isFieldValid(this.poBoxType) },
              h("agl-ds-dropdown-option", { text: "CMA", value: "CMA" }),
              h("agl-ds-dropdown-option", { text: "CPA", value: "CPA" }),
              h("agl-ds-dropdown-option", { text: "CMB", value: "CMB" }),
              h("agl-ds-dropdown-option", { text: "GPO BOX", value: "GPO BOX" }),
              h("agl-ds-dropdown-option", { text: "LOCKED BAG", value: "LOCKED BAG" }),
              h("agl-ds-dropdown-option", { text: "MS", value: "MS" }),
              h("agl-ds-dropdown-option", { text: "PO BOX", value: "PO BOX" }),
              h("agl-ds-dropdown-option", { text: "POSTE RESTANTE", value: "POSTE RESTANTE" }),
              h("agl-ds-dropdown-option", { text: "PRIVATE BAG", value: "PRIVATE BAG" }),
              h("agl-ds-dropdown-option", { text: "RMB", value: "RMB" }),
              h("agl-ds-dropdown-option", { text: "RMS", value: "RMS" }),
              h("agl-ds-dropdown-option", { text: "RMD", value: "RMD" }))),
          h("div", { class: "col-sm-12 col-md-6" },
            h("agl-ds-textbox", { id: this.poBoxNumber, textBoxId: this.poBoxNumber + '_textBox', label: "PO Box Number", maxLength: 100, validationText: "PO Box number required", value: this.addressDetailState[this.poBoxNumber], onTextboxBlur: (e) => {
                this.handleFieldBlur(this.poBoxNumber, e.detail.target.value);
              }, hasError: !this.isFieldValid(this.poBoxNumber) })))),
        h("agl-ds-textbox", { id: this.suburb, textBoxId: this.suburb + '_textBox', label: "Suburb", maxLength: 100, inputType: "text", validationText: "Suburb required", value: this.addressDetailState[this.suburb], onTextboxBlur: (e) => {
            this.handleFieldBlur(this.suburb, e.detail.target.value);
          }, hasError: !this.isFieldValid(this.suburb) }),
        h("div", { class: "row" },
          h("div", { class: "col-sm-12 col-md-6" },
            h("agl-ds-dropdownbox", { ref: (el) => (this.stateDropdown = el), id: this.state, selectId: this.state + '_dropdown', label: "State", validationText: "State selection required", hintText: "Select state", dropdownDirection: "up", value: this.addressDetailState[this.state], onDropdownClosed: (e) => {
                this.handleFieldBlur(this.state, e.detail);
              }, onOptionSelected: (e) => {
                this.handleFieldBlur(this.state, e.detail.value);
              }, hasError: !this.isFieldValid(this.state) },
              h("agl-ds-dropdown-option", { text: "ACT", value: "ACT" }),
              h("agl-ds-dropdown-option", { text: "NSW", value: "NSW" }),
              h("agl-ds-dropdown-option", { text: "NT", value: "NT" }),
              h("agl-ds-dropdown-option", { text: "QLD", value: "QLD" }),
              h("agl-ds-dropdown-option", { text: "SA", value: "SA" }),
              h("agl-ds-dropdown-option", { text: "TAS", value: "TAS" }),
              h("agl-ds-dropdown-option", { text: "VIC", value: "VIC" }),
              h("agl-ds-dropdown-option", { text: "WA", value: "WA" }))),
          h("div", { class: "col-sm-12 col-md-6" },
            h("agl-ds-textbox", { ref: (el) => (this.postcodeDropdown = el), id: this.postcode, textBoxId: this.postcode + '_textBox', label: "Postcode", maxLength: 4, inputType: "number", validationText: "Postcode required (e.g. 3123)", hintText: "e.g. 3123", value: this.addressDetailState[this.postcode], onTextboxBlur: (e) => {
                this.handleFieldBlur(this.postcode, e.detail.target.value);
              }, hasError: !this.isFieldValid(this.postcode) })))),
      h("div", { slot: "footer" },
        h("div", { class: "row" },
          h("div", { class: "manual-address-entry__button col-sm-12 col-md-6" },
            h("agl-ds-button", { type: "tertiary", iconPosition: "left", onClick: () => {
                this.modalContainer.closeModal('manualReturn');
              }, icon: leftArrow }, "Return to address finder")),
          h("div", { class: "manual-address-entry__button col-sm-12 col-md-6" },
            h("agl-ds-button", { type: "primary", onClick: () => {
                this.isFormInvalid = !this.validateForm();
                if (!this.isFormInvalid) {
                  this.clearValueOnUnrequiredFields();
                  this.addressConfirm.emit(this.modifyAddressDetails(this.addressDetailState, false));
                  this.modalContainer.closeModal();
                }
                else {
                  setTimeout(() => this.errorNotification.setFocus(), 0);
                }
              } }, "Add address"))))));
  }
  static get is() { return "agl-ds-manual-address-entry"; }
  static get encapsulation() { return "scoped"; }
  static get originalStyleUrls() { return {
    "$": ["./manual-address-entry.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["manual-address-entry.css"]
  }; }
  static get properties() { return {
    "manualAddressId": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The manual address ID"
      },
      "attribute": "manual-address-id",
      "reflect": false,
      "defaultValue": "generateRandomNumber()"
    },
    "heading": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Heading for the modal"
      },
      "attribute": "heading",
      "reflect": false,
      "defaultValue": "''"
    },
    "includePobox": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "includePobox will give option to choose postal/pobox, which indicates a mailing address entry."
      },
      "attribute": "include-pobox",
      "reflect": false,
      "defaultValue": "false"
    },
    "defaultAddressDetail": {
      "type": "unknown",
      "mutable": false,
      "complexType": {
        "original": "AddressDetailModel",
        "resolved": "AddressDetailModel",
        "references": {
          "AddressDetailModel": {
            "location": "import",
            "path": "../address.model"
          }
        }
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Default form value as object"
      },
      "defaultValue": "{}"
    }
  }; }
  static get states() { return {
    "addressDetailState": {},
    "addressTypeState": {},
    "invalidFields": {},
    "isFormInvalid": {},
    "firstInvalidInputId": {}
  }; }
  static get events() { return [{
      "method": "addressConfirm",
      "name": "addressConfirm",
      "bubbles": true,
      "cancelable": true,
      "composed": true,
      "docs": {
        "tags": [],
        "text": "Forwards address details when address confirm"
      },
      "complexType": {
        "original": "AddressDetailModel",
        "resolved": "AddressDetailModel",
        "references": {
          "AddressDetailModel": {
            "location": "import",
            "path": "../address.model"
          }
        }
      }
    }, {
      "method": "addressCloseAction",
      "name": "addressCloseAction",
      "bubbles": true,
      "cancelable": true,
      "composed": true,
      "docs": {
        "tags": [],
        "text": "Forwards the manual address modal close action"
      },
      "complexType": {
        "original": "ModalCloseAction",
        "resolved": "\"clickOutside\" | \"iconButton\" | \"manual\" | \"manualReturn\"",
        "references": {
          "ModalCloseAction": {
            "location": "import",
            "path": "../../../core/modal/modal/modal.types"
          }
        }
      }
    }]; }
  static get methods() { return {
    "openModal": {
      "complexType": {
        "signature": "(el: HTMLElement) => Promise<void>",
        "parameters": [{
            "tags": [{
                "text": "el , the element need to be focused after modal close",
                "name": "param"
              }],
            "text": ", the element need to be focused after modal close"
          }],
        "references": {
          "Promise": {
            "location": "global"
          },
          "HTMLElement": {
            "location": "global"
          }
        },
        "return": "Promise<void>"
      },
      "docs": {
        "text": "Public method to open the modal",
        "tags": [{
            "name": "param",
            "text": "el , the element need to be focused after modal close"
          }, {
            "name": "deprecated",
            "text": "This will not be supported when the parameter is removed from the modal"
          }]
      }
    },
    "setTriggerButton": {
      "complexType": {
        "signature": "(getTriggerButton: () => HTMLElement) => Promise<void>",
        "parameters": [{
            "tags": [{
                "text": "getTriggerButton , The anonymous function that returns the element that needs to be focused after modal close",
                "name": "param"
              }],
            "text": ", The anonymous function that returns the element that needs to be focused after modal close"
          }],
        "references": {
          "Promise": {
            "location": "global"
          },
          "HTMLElement": {
            "location": "global"
          }
        },
        "return": "Promise<void>"
      },
      "docs": {
        "text": "Public method to set the modal trigger element",
        "tags": [{
            "name": "param",
            "text": "getTriggerButton , The anonymous function that returns the element that needs to be focused after modal close"
          }]
      }
    }
  }; }
  static get watchers() { return [{
      "propName": "addressTypeState",
      "methodName": "updateWhenAddressTypeChange"
    }, {
      "propName": "addressDetailState",
      "methodName": "updateRequiredfieldsWhenPoBoxTypeChange"
    }, {
      "propName": "invalidFields",
      "methodName": "updateFirstInvalidInputId"
    }]; }
}
